import { render, staticRenderFns } from "./treeSingleSelection.vue?vue&type=template&id=4a99d44f&scoped=true&"
import script from "./treeSingleSelection.vue?vue&type=script&lang=js&"
export * from "./treeSingleSelection.vue?vue&type=script&lang=js&"
import style0 from "./treeSingleSelection.vue?vue&type=style&index=0&id=4a99d44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99d44f",
  null
  
)

export default component.exports